export default __webpack_public_path__ + "static/media/hammer.e785a032.png";